export default {
  freeTrial: 'free_trial',
  free: 'free',
  paid: 'paid',
};
